import $ from 'cash-dom';
import DeviceSizes from './DeviceSizes';
import Utils from './Utils';
import Popup from './popup';

const ScoreTooltip = {
	$scoreTooltipHolder: null,
	$scoreTooltipInfoTitle: null,
	$scoreTooltipLinkDesktop: null,
	haveHandlers: false,

	init() {
		const self = this;

		self._initSelectors();
		self._initHandlers();

		const clickHandler = function (e) {
			const $target = $(e.target);

			if (!($target.hasClass('score-tooltip-holder')
				|| $target.closest('.score-tooltip-holder').length
				|| $target.hasClass('with-score-tooltip-link')
				|| $target.closest('.with-score-tooltip-link').length)) {
				self._hideAllTooltips();
			}

			if (!($target.closest('.score-tooltip-title').length || $target.hasClass('score-tooltip-title')
				|| $target.closest('.score-tooltip-content').length)) {
				self._hideAllTooltipInfo();
			}
		};

		$(document).on('click', clickHandler);

		$(document).on('update-score-tooltip-click-handler', () => {
			$(document).off('click', clickHandler);
			$(document).on('click', clickHandler);

			self._initSelectors();
			self._initHandlers();
		});

		$(window).on('resize', function () {
			self._hideAllTooltips();
		});

		if (Utils.getHasVendorsListCarousel()) {
			// if we have VendorsListCarousel, we need to handle only the `vendors-list-carousel-mounted` event
			// bacuase the `vendors-list-carousel-mounted` event is triggered after the `filters-change` event.
			$(document).on('vendors-list-carousel-mounted', () => {
				self._initSelectors();
				self._initHandlers();
			});
		} else {
			$(document).on('filters-change', () => {
				self._initSelectors();
				self._initHandlers();
			});
		}
	},

	_initSelectors() {
		this.$scoreTooltipHolder = $('.score-tooltip-holder');
		this.$scoreTooltipInfoTitle = $('.score-tooltip-info .score-tooltip-title');
		this.$scoreTooltipLinkDesktop = $('.with-score-tooltip-link-desktop');
	},

	_initHandlers() {
		const self = this;

		self._offHandlers();

		$('.with-score-tooltip-link').on('click', this._withScoreTooltipLinkHandler);
		self.$scoreTooltipLinkDesktop.on('click', this._scoreTooltipLinkDesktopHandler);

		self.$scoreTooltipLinkDesktop.find('.close-button').on('click', function (e) {
			e.preventDefault();
			self._hideClosestTooltip(this);
		});

		self.$scoreTooltipHolder.find('.close-button').on('click', function (e) {
			e.preventDefault();
			self._hideClosestTooltip(this);
		});

		self.$scoreTooltipHolder.find('.score-value').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
		});

		self.$scoreTooltipInfoTitle.on('click', this._scoreTooltipInfoTitleHandler);

		self.$scoreTooltipInfoTitle.closest('.score-tooltip-info').find('.close-button').on('click', function (e) {
			e.preventDefault();
			self._hideTooltipInfo(this);
		});

		this.haveHandlers = true;
	},

	_offHandlers() {
		if (!this.haveHandlers) {
			return;
		}

		$('.with-score-tooltip-link').off('click', this._withScoreTooltipLinkHandler);
		this.$scoreTooltipLinkDesktop.off('click', this._scoreTooltipLinkDesktopHandler);
		this.$scoreTooltipInfoTitle.off('click', this._scoreTooltipInfoTitleHandler);
	},

	_withScoreTooltipLinkHandler(e) {
		e.preventDefault();
		ScoreTooltip._showClosestTooltip(this);
	},

	_scoreTooltipLinkDesktopHandler(e) {
		e.preventDefault();
		ScoreTooltip._showClosestTooltip(this);
	},

	_scoreTooltipInfoTitleHandler(e) {
		e.preventDefault();
		ScoreTooltip._showTooltipInfo(this);
	},

	_showClosestTooltip(element) {
		const $ppcSingleVendor = $(element).closest('.ppc-single-vendor, .mid-chart-banner-container');
		const mobileWidth = $ppcSingleVendor.hasClass('show-tooltip-tablet-as-desktop') ? DeviceSizes.SM : DeviceSizes.MD;

		const desktopOrMobileClass = window.innerWidth < mobileWidth ? '.mobile' : '.desktop';

		this._hideAllTooltips();

		const $scoreTooltipHolder = $ppcSingleVendor.find('.score-tooltip-holder' + desktopOrMobileClass);

		const mobileWidthForPopup = $scoreTooltipHolder.data('mobile-width') || mobileWidth;
		const isPopupOnMobile = window.innerWidth < mobileWidthForPopup && $scoreTooltipHolder.hasClass('popup-on-mobile');

		if (isPopupOnMobile) {
			const popup = new Popup();
			popup.show('<div class="score-tooltip-holder">' + $scoreTooltipHolder.html() + '</div>', 'score-tooltip-popup');
		} else {
			this._adjustScoreTooltipHolderTopIfNeeded({$ppcSingleVendor, desktopOrMobileClass, $scoreTooltipHolder});
			$ppcSingleVendor.addClass('with-open-score-tooltip');
			$scoreTooltipHolder.show();
		}
	},

	_hideAllTooltips() {
		this.$scoreTooltipHolder.hide();
		$('.ppc-single-vendor, .mid-chart-banner-container').removeClass('with-open-score-tooltip');
	},

	_adjustScoreTooltipHolderTopIfNeeded({$ppcSingleVendor, desktopOrMobileClass, $scoreTooltipHolder}) {
		if ($ppcSingleVendor.hasClass('add-col-special-offer-height-to-mobile') && desktopOrMobileClass === '.mobile') {
			const colSpecialOfferHeight = $ppcSingleVendor.find('.col-special-offer').outerHeight(true);

			if (colSpecialOfferHeight) {
				const initialTop = $scoreTooltipHolder.data('initial-top') || $scoreTooltipHolder.css('top');
				$scoreTooltipHolder.data('initial-top', initialTop);
				$scoreTooltipHolder.css('top', `${parseInt(initialTop) + colSpecialOfferHeight}px`);
			}
		}
	},

	_hideClosestTooltip(element) {
		const $vendorCard = $(element).closest('.ppc-single-vendor, .mid-chart-banner-container');
		$vendorCard.find('.score-tooltip-holder').hide();
		$vendorCard.removeClass('with-open-score-tooltip');
	},

	_showTooltipInfo(tooltipInfoHolder) {
		const $tooltipInfo = $(tooltipInfoHolder).closest('.score-tooltip-info');
		const isMobileFixedTooltip = this._isMobileFixedTooltip();

		if (isMobileFixedTooltip) {
			this._hideAllTooltipInfo();
			this._ensureMobileFixedTitle($tooltipInfo);
			$tooltipInfo.addClass('is-open');
		}

		$tooltipInfo.find('.score-tooltip-content').show();
		$(document).trigger('accordion-open-active-panel');
	},

	_hideTooltipInfo(tooltipInfoHolder) {
		const $tooltipInfo = $(tooltipInfoHolder).closest('.score-tooltip-info');
		$tooltipInfo.removeClass('is-open');
		$tooltipInfo.find('.score-tooltip-content').hide();
	},

	_hideAllTooltipInfo() {
		$('.score-tooltip-info').removeClass('is-open');
		$('.score-tooltip-info .score-tooltip-content').hide();
	},

	_isMobileFixedTooltip() {
		const hasBodyClass = document.body.classList.contains('score-tooltip-mobile-fixed');
		return hasBodyClass && window.innerWidth < DeviceSizes.MD;
	},

	_ensureMobileFixedTitle($tooltipInfo) {
		const $tooltipContent = $tooltipInfo.find('.score-tooltip-content');

		if (!$tooltipContent.length || $tooltipContent.find('.score-tooltip-mobile-title').length) {
			return;
		}

		const titleText = $tooltipInfo.find('.score-tooltip-text').first().text();
		$tooltipContent.prepend(`<div class="score-tooltip-mobile-title">${titleText}</div>`);
	},
};

export default ScoreTooltip;
